import { useState, useLayoutEffect } from 'react';
import styles from '../styles/body.module.scss'
import btnStyles from '../styles/buttons.module.scss'
import Button from '@mui/material/Button';
import axios from '../api/axios';
import useAxios from "../hooks/useAxios";
import useAxiosFunction from '../hooks/useAxiosFunction';
import Autocomplete from '@mui/material/Autocomplete';
import {Box, TextField} from '@mui/material';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import { useNavigate } from 'react-router-dom';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import UploadIcon from '@mui/icons-material/Upload';
import CircularProgress from '@mui/material/CircularProgress';
import{BottomNavigation, BottomNavigationAction} from '@mui/material'

export default function Contact({siteId, setSiteId, nameOfCompleting, setNameOfCompleting, dateError, setDateError,timeDate, setTimeDate, userType, setUserType,
    categoryId, setCategoryId, description, setDescription,
    contacted, setContacted, contactEmail, setContactEmail, contactNumber, setContactNumber, imgFile, setImgFile, file, setFile
}) {

  const navigate = useNavigate();
  const goBack = () => navigate(-1);

  const [response, error, loading, axiosFetch] = useAxiosFunction();

  const [progress, setProgress] = useState(false);
  const [result, setResult] = useState(false);
  const [imgResult, setImgResult] = useState(false);

  useLayoutEffect(() => {
    if(result && imgResult){
      setResult(false);
      setImgResult(false);
      submitAction();
    }
    
  }, [result, imgResult])


  useLayoutEffect(() => {
    if(contacted == 'true'){
      setDisplaySection(true);
  }
  else if (contacted == 'false'){
      setDisplaySection(false);
  }
    
  }, []);



  const [displaySection, setDisplaySection] = useState(false);

  const [contactedError, setContactedError] = useState(false);
  const [contactedText, setContactedText] = useState('');


  const [emailError, setEmailError] = useState(false);
  const [emailText, setEmailText] = useState('');

  const [numberError, setNumberError] = useState(false);
  const [numberText, setNumberText] = useState('');
  var phone_number_regex =/^\+?([0-9]\s*){11,17}$/;
  var email_regex = /^[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,125}[a-zA-Z]{2,63}$/;

  const contactedChange = (e) =>{
    if(e.target.value == 'true'){
        setDisplaySection(true);
    }
    else{
        setDisplaySection(false);
    }
    setContacted(e.target.value);
  }

  const handleContactEmailChange = (newValue) => {
      setContactEmail(newValue);
  }

  const handleContactNumberChange = (newValue) => {
      setContactNumber(newValue);
  };

  const nextPage = () =>{
    if(contacted != null){
      setContactedText('');
      setContactedError(false);
      setEmailText('');
      setEmailError(false);
      setNumberText('');
      setNumberError(false);

      if (contacted == 'true') {
        if ((contactEmail == null || contactEmail == '') && (contactNumber == null || contactNumber == '')) {
          setEmailText('Please provide a valid contact email address and/or a valid contact phone number');
          setEmailError(true);
          setNumberText('Please provide a valid contact email address and/or a valid contact phone number');
          setNumberError(true);
        }
        else {
          if (contactEmail.length == 0 && contactNumber.length == 0) {
            setEmailText('Please provide a valid contact email address');
            setEmailError(true);

            setNumberText('Please provide a valid contact phone number');
            setNumberError(true);
          }
          else if (contactEmail.length > 0 && !email_regex.test(contactEmail)) {
            setEmailText('Please provide a valid contact email address');
            setEmailError(true);
          }
          else if (contactNumber.length > 0 && !phone_number_regex.test(contactNumber)) {
            setNumberText('Please provide a valid contact phone number');
            setNumberError(true);
          }
          else {
            //SUBMIT FORM
            setProgress(true);
            submit();
          }
        }
      }
      else if (contacted == 'false'){
        //SUBMIT FORM
        setProgress(true);
        submit();

      }
  }
    else {
      setContactedText('');
      setContactedError(false);
      if (contacted == null) {
        setContactedText('Please select an option');
        setContactedError(true);
      }
    }

  }

  const submit = async e => {
    const bodyObj = JSON.stringify({
      "siteId": siteId? siteId.id : 0,
      "timeDate": timeDate,
      "nameOfCompleting": nameOfCompleting,
      "userType": userType,
      "categoryId":categoryId? categoryId.category_order : 0,
      "description": description,
      "contacted":contacted,
      "contactEmail":contactEmail,
      "contactNumber":contactNumber
    });

    try {
      await axiosFetch({
        axiosInstance: axios,
        method: 'post',
        url: '/createObservation',
        requestConfig: {
          headers: {
            'Content-Type': 'application/json',
          },
          data: bodyObj
        }

      })
    } catch (err) {
      console.log(err);

    }
    if(Array.isArray(file) && file.length){
      imageUpload();
      setResult(true);

    }
    else{
      setResult(true);
      setImgResult(true);
    }

  }

  function submitAction() {
    if (response.status === 200) {
      setProgress(false);
      clear();
      navigate("/success");
    }  
    else {
      console.log(response);
    }

  }

  const imageUpload = async e => {
    console.log(imgFile);
    try {
      await axiosFetch({
        axiosInstance: axios,
        method: 'post',
        url: '/imageUpload',
        requestConfig: {
          headers: {},
          data:imgFile
        }

      })
      setImgResult(true);
    } catch (err) {
      console.log(err);

    }
  }

  function clear(){
    setSiteId(null);
    setTimeDate(null);
    setNameOfCompleting("");
    setUserType("");
    setCategoryId(null);
    setDescription("");
    setContacted(null);
    setContactEmail("");
    setContactNumber("");
    setImgFile();
    setFile();
  }

  const exceptThisSymbols = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9","Backspace", " "];
  return (
    <div>
    <Box className={styles.questionH1Top} >
        <h1>Would you like to hear back from Dandara management on your observation?</h1>
        </Box>
        <Box className={styles.radioGroup}>
        <FormControl sx={{ m: 3 }} error={contactedError} variant="standard">
      <RadioGroup
        row
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
        value={contacted}
        onChange={contactedChange}
      >
        <FormControlLabel sx={{'& .MuiFormControlLabel-label': {fontSize: '1.3rem'}}}value={true} control={<Radio sx={{'& .MuiSvgIcon-root': {fontSize: 30}}}/>} label="Yes" />
        <FormControlLabel sx={{'& .MuiFormControlLabel-label': {fontSize: '1.3rem'}}}value={false} control={<Radio sx={{'& .MuiSvgIcon-root': {fontSize: 30}}}/>} label="No" />
      </RadioGroup>
      <FormHelperText>{contactedText}</FormHelperText>
    </FormControl>
    </Box>
    {displaySection ?
            <>
            <Box className={styles.questionH1} >
              <h1>Please provide your email address and/or phone number</h1>
          </Box>
          <Box className={styles.textField}>
                <FormControl fullWidth margin="normal" className={styles.field} error={emailError}>
                <TextField  error={emailError} value={contactEmail} fullWidth id="outlined-basic" label="Contact Email Address" variant="outlined" onChange={e => handleContactEmailChange(e.target.value)}  />
                <FormHelperText>{emailText}</FormHelperText>
                </FormControl>
                </Box>
          <Box className={styles.textField} >
              <FormControl fullWidth margin="normal" className={styles.field} error={numberError}>
                  <TextField error={numberError} value={contactNumber} type="tel" pattern="[0-9]*"
                      onKeyDown={e => !exceptThisSymbols.includes(e.key) && e.preventDefault()}
                      fullWidth id="outlined-basic" label="Contact Phone Number" variant="outlined" onChange={e => handleContactNumberChange(e.target.value)} />
                  <FormHelperText>{numberText}</FormHelperText>
              </FormControl>
          </Box>
            
            
            </>
            :
            <></>}




        <Box className={styles.progressBar}>
                {progress && <CircularProgress size="5rem"/>} 
                </Box>

          <Box className={btnStyles.navbuttons} >
              <Button startIcon={<ArrowBackIosNewIcon />} className={btnStyles.backBtn} size="large" variant="contained" onClick={() => goBack()}>Back</Button>
              <Button disabled={progress} startIcon={<UploadIcon />} className={btnStyles.nextBtn} size="large" variant="contained"
          onClick={() => nextPage()} >Submit</Button>

          </Box>
          <Box className={btnStyles.bottomNavContainer}>
              <BottomNavigation sx={{
                  width: '100%',
                  position: 'fixed',
                  bottom: 0,
                  height:'70px',
                  zIndex: '1000'
              }} showLabels>
                  <BottomNavigationAction id="navBackButton" label='Back' icon={<ArrowBackIosNewIcon />} onClick={() => goBack()} />
                  <BottomNavigationAction disabled={progress} id="navNextButton" label='Submit' icon={<UploadIcon />} onClick={() => nextPage()} />
              </BottomNavigation>
          </Box>           
        
    </div>
  );
}

